export default __webpack_public_path__ + "static/media/logo-horizontal.75bc7c31.png";